module.exports = __webpack_public_path__ + "media/images/redesign-images/how-it-works/icons/icon-laptop-993e13a9b3ea30a71533c0b24a77048a.svg";